import { Features } from 'generated/featureDefinitions'

import {
  A3INNUVA_INTEGRATION_ID,
  ACICATECH_BUSINESS_CENTRAL_ID,
  BIT_TECHNOLOGIES_ORACLE_NET_SUITE_ID,
  DATEV_FACTORIAL_INTEGRATION_ID,
  MILENA_ILLUSION_INTEGRATION_ID,
  SAGE200_GMINTEGRA_ID,
  SILAE_FORTIFY_INTEGRATION_ID,
  SUPREMA_XIPTIC_INTEGRATION_ID,
} from 'modules/marketplace/lib/integrationIds'

export interface UpsellableIntegration {
  id: Features
}

// Once we have more integrations that require upsell, we will add logic to the backend
export const upsellableIntegrations: Record<string, UpsellableIntegration> = {
  [BIT_TECHNOLOGIES_ORACLE_NET_SUITE_ID]: {
    id: Features.marketplace_oracle_netsuite_integration,
  },
  [ACICATECH_BUSINESS_CENTRAL_ID]: {
    id: Features.marketplace_business_central_integration,
  },
  [SAGE200_GMINTEGRA_ID]: {
    id: Features.marketplace_sage200_gmintegra_integration,
  },
  [DATEV_FACTORIAL_INTEGRATION_ID]: {
    id: Features.marketplace_datev_factorial_integration,
  },
  [MILENA_ILLUSION_INTEGRATION_ID]: {
    id: Features.marketplace_milena_illusion_integration,
  },
  [SUPREMA_XIPTIC_INTEGRATION_ID]: {
    id: Features.marketplace_suprema_xiptic_integration,
  },
  [A3INNUVA_INTEGRATION_ID]: {
    id: Features.marketplace_a3innuva_integration,
  },
  [SILAE_FORTIFY_INTEGRATION_ID]: {
    id: Features.marketplace_silae_fortify_integration,
  },
}
